import React from 'react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper.less';
import 'swiper/components/navigation/navigation.less';
import 'swiper/components/pagination/pagination.less';
import 'swiper/components/scrollbar/scrollbar.less';

SwiperCore.use([Navigation, Pagination]);

const Slider = (props) => {
  return (
    <Swiper {...props.attrs}>
      {props.items.map((item, index) => {
        return <SwiperSlide key={item + index}>{item}</SwiperSlide>;
      })}
    </Swiper>
  );
};

export default Slider;
